/* eslint-disable no-labels,no-trailing-spaces,key-spacing,no-unused-expressions,no-unused-vars */
const IMAGE = {
  // 资源图片地址
  logo: {
    fzkLogo:require(`@/assets/images/logo/fzkLogo.png`),
    zhwlLogo:require(`@/assets/images/logo/zhwlLogo.png`),
  },
  homepagePic:require('@/assets/images/img/homePage.png'),
  icon:{
    dailyActive: require('@/assets/images/icon/dailyActive.png'),
    homepageLogo: require('@/assets/images/icon/homepageLogo.png'),
    timelyActive: require('@/assets/images/icon/timelyActive.png'),
    useInstru: require('@/assets/images/icon/useInstru.png'),
    weChatSign: require('@/assets/images/icon/wechatSign.png'),
    signIn: require('@/assets/images/icon/signIn.png'),
    signOut: require('@/assets/images/icon/signOut.png'),
    activeCatalog: require('@/assets/images/icon/activeCatalog.png'),
    rightArrow: require('@/assets/images/icon/rightArrow.png'),
    transRightArrow: require('@/assets/images/icon/transRightArrow.png'),
    chongzhi: require('@/assets/images/icon/chongzhi.png'),
    order: require('@/assets/images/icon/order.png'),
    fzkHome:{
      activity: require('@/assets/images/icon/fzkHome/activity.png'),
      catalog: require('@/assets/images/icon/fzkHome/catalog.png'),
      dailyActivity: require('@/assets/images/icon/fzkHome/dailyActivity.png'),
      signIn: require('@/assets/images/icon/fzkHome/signIn.png'),
      signOut: require('@/assets/images/icon/fzkHome/signOut.png'),
      useInstru: require('@/assets/images/icon/fzkHome/useInstru.png'),
      wxSignIn: require('@/assets/images/icon/fzkHome/wxSignIn.png'),
      setting: require('@/assets/images/icon/fzkHome/setting.png'),
      markOrder: require('@/assets/images/icon/fzkHome/markOrder.png'),
      outRecord: require('@/assets/images/icon/fzkHome/outRecord.png'),
      outRecordCount: require('@/assets/images/icon/fzkHome/outRecordCount.png'),
      notice: require('@/assets/images/icon/fzkHome/notice.png'),
      questionnaire: require('@/assets/images/icon/fzkHome/questionnaire.png'),
      newdpc: require('@/assets/images/icon/eat.png'),
      outRecordStatistics: require('@/assets/images/icon/fzkHome/outRecordStatistics.png'),
    },
    archives:{
      workbench: require('@/assets/images/icon/archives/workbench.svg'),
      buildingStatus: require('@/assets/images/icon/archives/buildingStatus.svg'),
      takeMeal: require('@/assets/images/icon/archives/takeMeal.svg'),
      roomStatus: require('@/assets/images/icon/archives/roomStatus.svg'),
      nursingTask: require('@/assets/images/icon/archives/nursingTask.svg'),
      banner: require('@/assets/images/icon/archives/banner.jpg'),
      bucket: require('@/assets/images/icon/archives/bucket.svg'),

    },
    homeCare:{
      homeSiteAppointment: require('@/assets/images/icon/homeCare/homeSiteAppointment.svg'),
    }
  },
  global:{
    empty: require('@/assets/images/global/empty.png'),
    people_info: require('@/assets/images/global/people_info.png'),
    wxSignIn: require('@/assets/bg/wxSignIn.jpg'),
    defaultPortrait: require('@/assets/images/global/default_portrait.jpg'),
    defaultGirl: require('@/assets/images/global/defaultGirl.png'),
    bg_soul: require('@/assets/images/global/bg_soul.png'),
  },
  qrCode:{
    fzkQrCodeCircle: require('@/assets/images/qrCode/fzkQrCodeCircle.jpg'),
  },
  banner:{
    ban1: require('@/assets/images/banner/ban1.jpg'),
    ban2: require('@/assets/images/banner/ban2.jpg'),
    ban3: require('@/assets/images/banner/ban3.jpg'),
    ban4: require('@/assets/images/banner/ban4.jpg'),
    ban5: require('@/assets/images/banner/ban5.jpg'),
  },
  systemTipVoice: {
    clickVoice: require('@/assets/system/music/clickVoice.mp3'),
    successVoice: require('@/assets/system/music/successVoice.mp3'),
    selectFoodVoice: require('@/assets/system/music/selectFoodVoice.mp3'),
    thanksVoice: require('@/assets/system/music/thanksVoice.mp3'),
  },
  homeService:{
    homeService: require('@/assets/images/icon/homeService/homeService.png'),
  },
}
export default IMAGE



// WEBPACK FOOTER //
// ./src/config/src.js